export default "__VITE_ASSET__B9iDBKxu__"